export default __webpack_public_path__ + "static/cabin-basic-new-2-7820b5dd104e648a4599d6619323505e.jpg";